import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useConfigStore } from "../../store/store";
import { getTraceId } from "../../utils";

interface ErrorPageProps {
    message: string;
    traceId?: string;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ traceId, message }) => {

    const appInsights = useConfigStore(state => state.appInsights);
    if (traceId != undefined) {
        traceId = getTraceId(appInsights);
    }

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100vh",
                flexDirection: "column"
            }}
        >
            <Typography variant="h6" sx={{ marginTop: "16px", marginBottom: "16px" }}>
                {message}
            </Typography>
            <Button variant="contained" color="warning" onClick={() => window.location.reload()}>
                Refresh Page
            </Button>
            {traceId != "not_present" && (
                <Typography variant="body1" sx={{ marginTop: "16px" }}>
                    {"TraceId: " + traceId}
                </Typography>
            )}
        </Box>
    );
};

export default ErrorPage;
